import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Grid,
  Divider,
  TextField,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
} from "@mui/material";
import { useForm, Controller } from "react-hook-form";
import moment from "moment";

const certFields = [
  { label: "Cert No", key: "certNo" },
  { label: "ADM No", key: "admNo" },
  { label: "REG No", key: "regNo" },
  { label: "ROLL No", key: "rollNo" },
];

const numberedFields = [
  { index: "1.", label: "Name of the Pupil", key: "name" },
  { index: "2.", label: "Mother's Name", key: "motherName" },
  { index: "3.", label: "Father's Name", key: "fatherName" },
  { index: "4.", label: "Nationality", key: "nationality" },
  { index: "5.", label: "Date of Birth", key: "dob" },
  { index: "(In Words)", label: "", key: "(in words)" },
  {
    index: "6.",
    label: "Whether the candidate belongs to Schedule Caste or Schedule Tribe",
    key: "casteStatus",
  },
  {
    index: "7.",
    label: "Date of first Admission in the school with class",
    key: "date_of_adm_class",
  },
  {
    index: "8.",
    label: "Class in which the pupil last studied",
    key: "lastClass",
  },
  {
    index: "9.",
    label: "School/Board Annual examination last taken with result",
    key: "lastExamResult",
  },
  {
    index: "10.",
    label: "Whether failed, if so once/twice in the same class",
    key: "failHistory",
  },
  { index: "11.", label: "Subject Studied", key: "subjects" },
  {
    index: "12.",
    label: "Whether qualified for promotion to the higher class",
    key: "qualified_for_promotion",
  },
  {
    index: "If so, to which class",
    label: "",
    key: "promotionClass",
  },
  {
    index: "13.",
    label: "Month up to which the (pupil has paid) school dues",
    key: "feesPaidTill",
  },
  {
    index: "14.",
    label:
      "Any fee concession availed of: if so, the nature of such concession",
    key: "feeConcession",
  },

  { index: "15.", label: "Total No. of working days", key: "totalWorkingDays" },
  { index: "16.", label: "Total No. of present days", key: "totalPresentDays" },
  {
    index: "17.",
    label: "Whether NCC Cadet/Boy Scout/Girl Guide (details may be given)",
    key: "nccDetails",
  },
  {
    index: "18.",
    label:
      "Games played or extra-curricular activities (mention achievement level)",
    key: "activities",
  },
  { index: "19.", label: "General Conduct", key: "conduct" },
  {
    index: "20.",
    label: "Date of application for certificate",
    key: "applicationDate",
  },
  { index: "21.", label: "Date of issue of certificate", key: "issueDate" },
  {
    index: "22.",
    label: "Reason for leaving the school",
    key: "reasonLeaving",
  },
  { index: "23.", label: "Any other remark", key: "remark" },
];

const TransferCertificateForm = (studentData, ref, handleChange) => {
  console.log("Inside TC Form");
  console.log(studentData);
  return (
    <Box
      ref={ref}
      sx={{
        width: "210mm",
        minHeight: "297mm",
        p: 2,
        pt: 0.5,
        border: "2px solid black",
        boxSizing: "border-box",
        fontSize: "9px",
        fontFamily: "serif",
      }}
    >
      <style>
        {`@media print {
          @page {
            size: A4 portrait;
            margin: 10mm;
          }
        }`}
      </style>
      {/* Header */}
      <Box width="97%" bgcolor="grey.100" p={1.5}>
        <Grid container alignItems="center" justifyContent="space-between">
          <Grid item>
            <img
              src="/img/rps_logo.png"
              width={100}
              height={70}
              alt="School Logo"
            />
          </Grid>
          <Grid item xs textAlign="center" mr={4}>
            <Typography
              variant="h5"
              sx={{ fontFamily: "Alien Invader" }}
              fontSize={"2.5em"}
            >
              A.B.C Eduern Learning School
            </Typography>
            <Typography fontSize={"1.5em"}>
              Bairia, Daltonganj, Palamu - 822102 (Jharkhand)
            </Typography>
            <Typography variant="caption" fontSize={"1.2em"}>
              A Senior secondary (10+2), Affiliated to C.B.S.E, Delhi,
              Affiliation No. 3430175
            </Typography>
          </Grid>
        </Grid>
      </Box>

      {/* Certificate Title */}
      <Box
        display="flex"
        alignItems={"center"}
        justifyContent={"center"}
        width="100%"
        mt={1}
      >
        <Box
          sx={{
            border: "2px solid black",
            textAlign: "center",
            p: 1,
            mb: 1,
          }}
        >
          <Typography align="center" fontWeight="bold">
            SCHOOL LEAVING CERTIFICATE
          </Typography>
        </Box>
      </Box>

      {/* Certificate Numbers */}
      <Grid container spacing={0} sx={{ border: "2px solid black", mb: 1 }}>
        {certFields.map((field, i) => (
          <Grid
            item
            xs={3}
            key={field.key}
            sx={{
              borderRight: i < certFields.length - 1 ? "2px solid black" : 0,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              minHeight: 30,
              p: 0.5,
            }}
          >
            <Box
              display="flex"
              alignItems="center"
              width="100%"
              sx={{ gap: 0 }} // removes gap between items
              ml={
                field.label === "ADM No" ? 4 : field.label === "ROLL No" ? 3 : 1
              }
            >
              <Typography
                sx={{
                  fontSize: "0.80rem",
                  fontWeight: 500,
                  whiteSpace: "nowrap",
                }}
              >
                {field.label}
              </Typography>

              <TextField
                variant="standard"
                InputProps={{
                  disableUnderline: true,
                  sx: {
                    fontSize: "0.80rem",
                    padding: 0,
                    ml: 0.5,
                    flex: 1, // input takes remaining space
                    textTransform: "uppercase",
                  },
                }}
                inputProps={{
                  maxLength: 25,
                  style: {
                    textTransform: "uppercase",
                    textAlign: "left",
                  },
                }}
                value={studentData[field.key] || ""}
                onChange={(e) =>
                  handleChange(field.key, e.target.value.toUpperCase())
                }
              />
            </Box>
          </Grid>
        ))}
      </Grid>

      {/* Numbered Fields */}
      {numberedFields.map((field, idx) => (
        <Grid
          item
          key={field.key}
          sx={{
            lineHeight: "1em",
          }}
        >
          <Box display="flex" alignItems="center">
            <Typography
              noWrap
              sx={{
                fontSize: "0.95rem",
                minWidth: 300, // You can tweak this value based on longest label
                display: "inline-block",
                overflow: "hidden",
                textOverflow: "ellipsis",
                textAlign:
                  field.index === "(In Words)" ||
                  field.index === "If so, to which class"
                    ? "right"
                    : "",
              }}
            >
              {field.index} {field.label}
            </Typography>

            <Typography sx={{ mx: 1 }}>:</Typography>

            <Box flexGrow={1}>
              <TextField
                fullWidth
                multiline
                variant="standard"
                mt={1}
                InputProps={{
                  disableUnderline: true,
                  sx: {
                    fontSize: "0.95rem",
                    padding: "1",
                    fontWeight: "bold",
                    textTransform: "uppercase",
                    whiteSpace: "pre-wrap",
                    wordBreak: "break-word",
                  },
                }}
                value={studentData[field.key] || ""}
                onChange={(e) => {
                  handleChange(field.key, e.target.value.toUpperCase());
                }}
              />
            </Box>
          </Box>
        </Grid>
      ))}
      {/* Footer Signatures */}
      <Box sx={{ mt: 7, mb: -2 }}>
        {/* <Divider sx={{ borderColor: "black", mb: 1 }} /> */}
        <Grid container>
          <Grid item xs={4}>
            <Typography>Class Teacher</Typography>
          </Grid>
          <Grid item xs={4} textAlign="center">
            <Typography>Verified By</Typography>
          </Grid>
          <Grid item xs={4} textAlign="right">
            <Typography>Principal</Typography>
          </Grid>
        </Grid>
      </Box>

      {/* Bottom Line */}
      <Divider sx={{ borderColor: "black", mt: 3 }} />
      <Grid container mt={2}>
        <Grid item xs={4}>
          <Typography variant="caption">Website: www.testuser.com</Typography>
        </Grid>
        <Grid item xs={4} textAlign="center">
          <Typography variant="caption">Mobile No: 6205574800</Typography>
        </Grid>
        <Grid item xs={4} textAlign="right">
          <Typography variant="caption">
            Email: testuser66373@gmail.com
          </Typography>
        </Grid>
      </Grid>
    </Box>
  );
};

const TCForm_X = React.forwardRef((props, tableRefs) => {
  const [studentData, setStudentData] = useState({});

  useEffect(() => {
    console.log("TC Form Loaded");
    console.log(props);
    if (props.data && Object.entries(props).length > 0)
      setStudentData(props.data);
  }, []);

  const handleChange = (key, value) => {
    console.log("Handle Change Called", key);
    setStudentData((prev) => ({
      ...prev,
      [key]: value,
    }));

    if (key === "certNo") {
      props.onCertNoChange?.(value);
    }
  };

  const jsxElementArray = TransferCertificateForm(
    studentData,
    tableRefs,
    handleChange
  );

  return <>{jsxElementArray}</>;
});

export default TCForm_X;
